module.exports = __webpack_public_path__ + "static/media/info-circle.29811b29.svg";